
import Vue from 'vue'
import { ethers } from 'ethers'

export default Vue.extend({
  data () {
    return {
      tabs: [{
        title: "Create code",
        disabled: true
      },
      {
        title: "Redeem code",
        disabled: false
      }],
      selected: "Redeem code",
      createdCode: '28MCD-9KDJ2-0HK1O',
      code: <string | null> null,
      isRedeemingCode: false,
      errorPrompt: <string | null> null,
      redeemTx: <string | null> null
    }
  },
  computed: {
    address(): string | null {
      return this.$store.state.address
    },
    dataseed(): ethers.providers.Provider {
      return this.$store.getters.ecosystem.dataseed
    },
    displayedAddress(): string | null {
      if (!this.address) {
        return null
      }
      return this.address.substring(0, 12) + '...' + this.address.substring(this.address.length - 12)
    },
    validationStatus(): boolean {
      if (!this.code) {
        return false
      }

      return this.code.replaceAll('-', '').length == 16
    }
  },
  methods: {
    async redeemCoupon() {
      if (!this.code) {
        return
      }

      this.isRedeemingCode = true
      this.errorPrompt = null
      this.redeemTx = null
      try {
        const codeNoDashes = this.code.replaceAll('-', '')
        const response = await fetch('https://subgraph.toadlytics.com:6100/coupon/redeem', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            code: codeNoDashes,
            to: this.address
          })
        })
        if (response.status == 404) {
          this.errorPrompt = 'Code not valid. It may already be redeemed.'
          return
        }
        if (response.status != 200) {
          console.error(response)
          throw new Error()
        }
        const data = await response.json()
        this.redeemTx = data.tx
      } catch (e) {
        console.error(e)
        this.errorPrompt = 'Unexpected error. Please try again later.'
      } finally {
        this.isRedeemingCode = false
      }
    }
  }
})

